import React from "react";
import Btn from "../../Components/Btn/Btn";
import useVerifyCode from "./Hooks/useVerifyCode";
import { useLocation } from "react-router";
import Spinner from "react-bootstrap/Spinner";
import { from } from "jalali-moment";

const VerifyCode = () => {
  const { send, setForm, form, loading } = useVerifyCode();
  const { state } = useLocation();
  const { mobile } = state;
  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="verify-code">
            <div className="verify-box">
              <div className="verify-img">
                <img
                  src={require("../../assets/images/logo.png")}
                  style={{ width: "120px", objectFit: "contain" }}
                />
              </div>
              <div className="verify-title">
                <p className="title">کد تایید</p>
                <p className="content">لطفا کد ارسال شده را وارد نمایید</p>
              </div>
              <div className="verify-input">
                <input
                  className="content"
                  onChange={({ target: { value } }) => {
                    setForm({ code: value });
                  }}
                />
              </div>
              <div className="verify-button">
                <div
                  className="content"
                  onClick={() => {
                    send({ mobile, verifycode: form.code });
                  }}
                >
                  {loading ? (
                    <Spinner
                      animation="border"
                      role="status"
                      style={{ color: "white" }}
                      size="sm"
                    ></Spinner>
                  ) : (
                    <span className="textBtn">بررسی کد تایید</span>
                  )}
                </div>
              </div>
              <div className="verify-warning">
                <p className="text">
                  ورود شما به معنای قبول شرایط صنعتبان و قوانین حریم خصوصی می
                  باشد.
                </p>
              </div>
              <div className="verify-footnote">
                <p className="title">نیازمندی های رایگان صنعت</p>
                <p className="text">تلفن پشتیبانی: 02191027127</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyCode;
